// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nF-z","twoColumnImage":"oF-z"};